import { createSelector } from '@ngrx/store';
import { featureSelect } from '../settings';
const ɵ0 = (state) => state.brands;
export const getRecords = createSelector(featureSelect, ɵ0);
const ɵ1 = (state) => state.brandsDeleteError;
export const getDeleteError = createSelector(featureSelect, ɵ1);
export { ɵ0, ɵ1 };
